import {hr} from "./hr";

type languages = "HR" | "EN" | "IT";

export const languageOverrides: {
    [key: string]: Partial<{
        [key in keyof typeof hr]: { [key in languages]: string };
    }>;
} = {
    "MARSERVIS - MARSERVIS": {
        "codebooks-projects": {
            HR: "Plovila",
            EN: "Vessels",
            IT: "Navi",
        },
        project: {
            HR: "Plovilo",
            EN: "Vessel",
            IT: "Nave",
        },
        projectId: {
            HR: "Plovilo",
            EN: "Vessel",
            IT: "Nave",
        },
        projects: {
            HR: "Plovila",
            EN: "Vessels",
            IT: "Navi",
        },
        "adding-new-project": {
            IT: "Adding vessels",
            HR: "Dodavanje plovila",
            EN: "Adding vessels",
        },
        "editing-project": {
            EN: "Editing vessel",
            HR: "Uređivanje plovila",
            IT: "Editing vessel",
        },
        "no-projects-found": {
            IT: "No vessels found",
            HR: "Nisu pronađena plovila",
            EN: "No vessels found",
        },
        items: {
            IT: "Jobs",
            EN: "Jobs",
            HR: "Poslovi",
        },
        "codebooks-items": {
            IT: "Jobs",
            EN: "Jobs",
            HR: "Poslovi",
        },
        itemId: {
            IT: "Job",
            EN: "Job",
            HR: "Posao",
        },
        itemName: {
            IT: "Job",
            EN: "Job",
            HR: "Posao",
        },
        item_groups: {
            IT: "Job groups",
            EN: "Job groups",
            HR: "Grupe poslova",
        },
        "codebooks-item-groups": {
            HR: "Grupe poslova",
            IT: "Job groups",
            EN: "Job groups",
        },
        "item-group": {
            HR: "Grupa",
            IT: "Job group",
            EN: "Job group",
        },
        itemGroupId: {
            HR: "Grupa",
            IT: "Job group",
            EN: "Job group",
        },
        departmentId: {
            HR: "Odjel posla",
            IT: "Job department",
            EN: "Job department",
        },
        "adding-item": {
            EN: "Adding a job",
            HR: "Dodavanje posla",
            IT: "Adding a job",
        },
        "adding-item-group": {
            EN: "Adding job group",
            HR: "Dodavanje grupe posla",
            IT: "Adding job group",
        },
        "editing-item": {
            EN: "Editing job",
            HR: "Uređivanje posla",
            IT: "Editing job",
        },
        "editing-item-group": {
            EN: "Editing job group",
            IT: "Editing job group",
            HR: "Uređivanje grupe posla",
        },
        "connect-item": {
            EN: "Connect job",
            HR: "Poveži posao",
            IT: "Connect job",
        },
        "add-all-items-from-group": {
            EN: "Add jobs from group",
            IT: "Add jobs from group",
            HR: "Dodaj poslove iz grupe",
        },
        "connect-project": {
            EN: "Connect vessel",
            HR: "Poveži plovilo",
            IT: "Connect vessel",
        },
        "item-groups": {
            EN: "Job groups",
            HR: "Grupe posla",
            IT: "Job groups",
        },
        "department-items": {
            EN: "Department jobs",
            HR: "Poslovi odjela",
            IT: "Department jobs",
        },
        "The ProjectId field is required.": {
            EN: "Pick a vessel",
            HR: "Odaberite plovilo",
            IT: "Pick a vessel",
        },
        "The ItemId field is required.": {
            EN: "Odaberite posao",
            HR: "Odaberite posao",
            IT: "Odaberite posao",
        },
        projectName: {
            EN: "Vessel",
            HR: "Plovilo",
            IT: "Vessel",
        },
    },
    "Onix - ONIX_I": {
        support: {
            HR: "Grunf",
            EN: "Grunf",
            IT: "Grunf",
        },
        wiki: {
            HR: "Broj 1",
            EN: "Broj 1",
            IT: "Broj 1",
        },
        wiki_local: {
            HR: "Lokalni Broj 1",
            EN: "Lokalni Broj 1",
            IT: "Lokalni Broj 1",
        },
        scheduler: {
            HR: "Šef",
            EN: "Šef",
            IT: "Šef",
        },
        chatgpt: {
            HR: "Bob",
            EN: "Bob",
            IT: "Bob",
        },
    },
    "ONIX - TRIM": {
        support: {
            HR: "Grunf",
            EN: "Grunf",
            IT: "Grunf",
        },
        wiki: {
            HR: "Broj 1",
            EN: "Broj 1",
            IT: "Broj 1",
        },
        wiki_local: {
            HR: "Lokalni Broj 1",
            EN: "Lokalni Broj 1",
            IT: "Lokalni Broj 1",
        },
        scheduler: {
            HR: "Šef",
            EN: "Šef",
            IT: "Šef",
        },
        chatgpt: {
            HR: "Bob",
            EN: "Bob",
            IT: "Bob",
        },
        CLOSED: {
            HR: "Zaključen",
            EN: "Closed",
            IT: "Chiuso",
        },
    },
    "DANIELI - SYSTEC": {
        CLOSED: {
            HR: "Zaključen",
            EN: "Closed",
            IT: "Chiuso",
        },
    },
    "DANIELI - SYSTEC_TEST": {
        CLOSED: {
            HR: "Zaključen",
            EN: "Closed",
            IT: "Chiuso",
        },
    },
};
